import EPubModel from './models/EPubModel';
import EPubDeleteModel from './models/EPubDeleteModel';
import EPubSyncModel from './models/EPubSyncModel';
import EPubSyncAllModel from './models/EPubSyncAllModel';
import EPubFeatureModel from './models/EPubFeatureModel';

const EPubStore = {
  name: 'EPubStore',
  spec: EPubModel,
  saveLocally: false,
  initialState: {
    ePubs:[]
  },
};
const EPubDeleteResStore = {
  name: 'EPubDeleteResStore',
  spec: EPubDeleteModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};
const EPubSyncResStore = {
  name: 'EPubSyncResStore',
  spec: EPubSyncModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};
const EPubSyncAllResStore = {
  name: 'EPubSyncAllResStore',
  spec: EPubSyncAllModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};
const EPubFeatureResStore = {
  name: 'EPubFeatureResStore',
  spec: EPubFeatureModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};

const stores=[EPubStore,EPubDeleteResStore,EPubSyncResStore,EPubSyncAllResStore,EPubFeatureResStore];

export default stores;